import { Helmet } from "react-helmet-async";
import { CURRENT_URL } from "../../constants/configuration";
import { useLocation } from "react-router-dom";

const MetaHeader = ({ title, description, keywords, ogType = "website" }) => {
  const location = useLocation();
  
  const formattedTitle = title
    ? `${title}`
    : "Skyward Xperia ";
  const metaDescription =
    description || "Default description for Skyward Xperia.";
  const metaKeywords = keywords ;

  const canonicalUrl = `${CURRENT_URL}${location?.pathname}`;
  const ogImage = `${CURRENT_URL}/assets/img/about-package.jpg`;

  return (""
    // <Helmet>
    //   {/* Basic Meta Tags */}
    //   <title>{formattedTitle}</title>
    //   <meta name="description" content={metaDescription} />
    //   <meta name="keywords" content={metaKeywords} />

    //   {/* Canonical URL */}
    //   <link rel="canonical" href={canonicalUrl} />

    //   {/* Open Graph Meta Tags */}
    //   {/* <meta property="og:title" content={formattedTitle} />
    //   <meta property="og:description" content={metaDescription} />
    //   <meta property="og:type" content={ogType} />
    //   <meta property="og:image" content={ogImage} />
    //   <meta property="og:url" content={canonicalUrl} /> */}

    //   {/* Twitter Card Meta Tags */}
    //   <meta name="twitter:card" content="summary_large_image" />
    //   <meta name="twitter:title" content={formattedTitle} />
    //   <meta name="twitter:description" content={metaDescription} />
    //   <meta name="twitter:image" content={ogImage} />

    //   {/* Additional Meta Tags */}
    //   <meta name="robots" content="index, follow" />
    //   <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    //   <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
    // </Helmet>
  );
};

export default MetaHeader;
